<template>
    <div v-if="carregado">
        <site-erp v-if="app.tipo_site == 'ERP'" :app="app" :dados="dados" />
        <site-contabilidade
            v-if="app.tipo_site == 'CON'"
            :app="app"
            :dados="dados"
        />
    </div>
</template>
<script>
import SiteErp from './Erp'
import SiteContabilidade from './Contabilidade'
export default {
    components: {
        SiteErp,
        SiteContabilidade
    },
    data() {
        return {
            carregado: false,
            app: null,
            dados: {}
        }
    },
    mounted() {
        this.carregaDados()
    },
    methods: {
        async carregaDados() {
            const rDominio = await this.$api.get('/dominios/dados')
            if (rDominio.status == 'success') {
                this.app = rDominio.data.Dominio
                this.atualizaTitulo(rDominio.data.Dominio)
                this.atualizaIcone(rDominio.data.Dominio)
                if (rDominio.data.Dominio.script_chat_site) {
                    this.carregaScriptChat(
                        rDominio.data.Dominio.script_chat_site
                    )
                }
            } else {
                console.log(rDominio.message)
            }
            const rSite = await this.$api.get('/site/index')
            if (rSite.status == 'success') {
                this.dados = rSite.data
                if(rSite.redirect){
                    location.href = '/login'
                }
                this.carregado = true
            } else {
                console.log(rSite.message)
            }
        },
        carregaScriptChat(script) {

            let container = document.createElement('div');
            container.innerHTML = script;
            let scripts = container.querySelectorAll('script');
            let chat = document.createElement('script');
            chat.setAttribute('type', 'text/javascript')

            let scriptCodigo = scripts[0].innerHTML.replaceAll("“", '"');
            scriptCodigo = scriptCodigo.replaceAll("´", '"');

            chat.text = scriptCodigo;
            document.body.appendChild(chat)
        },
        atualizaTitulo(dados){
            document.title = (dados.nome || '') +  ' - Software de Gestão Online'
        },
        atualizaIcone(dados){
            document.querySelector('link[rel="icon"]').href = dados.caminho_favicon || ''
        },
    }
}
</script>
